export default __webpack_public_path__ + "static/img_1-a298fd786f96979cb4797701570fe528.png";